__turbopack_context__.v({
  "option": "MyNaviInput-module__RBPAoa__option",
});
